// tslint:disable:max-line-length

import React from 'react';

import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import { MarginWrapper } from '@travelnest/merlin.spacer';
import { Paragraph } from '../../paragraph/Paragraph';

interface ICalendarSyncImportWizardCompletedProps {
	propertyId: number | string;
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
}

export const CalendarSyncImportWizardCompleted: React.FC<ICalendarSyncImportWizardCompletedProps> = ({ onRequestPrevious, onRequestClose }) => {
	return (
		<Modal
			extraClasses="calendar-sync-modal calendar-sync-modal--import-complete"
			title="Import external calendar"
			onRequestClose={onRequestClose}
			shouldCloseOnOverlayClick={false}
			actionRHS={
				<Button
					id="calendar_import_completed_next"
					onClick={onRequestClose}
					buttonType={PresetThemes.Primary}
				>
					<span>Finish</span>
				</Button>
			}
			actionLHS={
				<Button
					id="calendar_import_completed_prev"
					onClick={onRequestPrevious}
				>
					<span>Back</span>
				</Button>
			}
		>
			<MarginWrapper>
				<h3>Your calendar is now importing.</h3>
				<Paragraph>We will start to import all events from the external calendar and block the dates on your Travelnest calendar.</Paragraph>
				<Paragraph>Check the calendar sync status table once you select finish to see the last imported events.</Paragraph>
			</MarginWrapper>
		</Modal>
	);
};
